import { atom } from "jotai";

export interface IInventoryItem {
    id?: number;
    trackable_item_id: string;
    purchase_order_id?: number | null;
    serial?: string | null;
    barcode?: string | null;
    zone_id?: number | null;
    unit_count?: number;
    stock_size_units?: number;
    status?: string;
    created_at?: string;
    updated_at?: string;
}

export interface IInventoryItemInput {
    trackable_item_id: string;
    purchase_order_id?: number | null;
    serial?: string | null;
    barcode?: string | null;
    zone_id?: number | null;
    unit_count?: number;
    stock_size_units?: number;
    status?: string;
}

export const inventoryItemsAtom = atom<IInventoryItem[]>([]);
export const inventoryItemsLoadingAtom = atom<boolean>(false);

